<template>
  <div>
    <v-dialog v-model="showEmployeeAdd" max-width="400">
      <v-card>
        <v-card-title class="headline"
          >Add Employees to "{{ list.name }}"</v-card-title
        >

        <v-card-text>
          <v-autocomplete
            label="Employee"
            :items="addableEmployees"
            item-text="name"
            item-value="id"
            v-model="addingEmployeesIDs"
            :loading="employeesLoading"
            :disabled="employeesLoading"
            multiple
            clearable
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="showEmployeeAdd = false"
            >Nevermind</v-btn
          >
          <v-btn
            color="success"
            @click="addEmployeeIDsToList"
            :disabled="addCallPending || addingEmployeesIDs.length === 0"
            :loading="addCallPending"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout column>
      <HeaderBar>
        {{ list.name }}
        <template slot="buttons">
          <router-link :to="{ name: 'employeeWatchListIndex' }" class="mr-2">
            All lists
          </router-link>
          <v-btn @click="openAddDialog" color="success">
            <v-icon left>
              add
            </v-icon>
            Add Employees
          </v-btn>
        </template>
      </HeaderBar>


      <v-progress-linear indeterminate v-if="pending" />
      <v-flex v-else>
        <v-data-table
          :items="employeesOnList"
          item-key="id"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'employeeDetail', params: { employeeId: item.id } }" target="_blank">
                {{ item.display_name }}
                </router-link>
              </td>
              <td style="text-align: right;">
                <v-btn @click="removeEmployeeID(item.id)" icon color="error" flat>
                  <v-icon>
                    delete
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import employeeWatchListAPI from '@/api/employeeWatchList'
import collectionApi from '@/api/collections'

export default {
  data() {
    return {
      listID: 0,
      list: {},
      addingEmployeesIDs: [],
      pending: false,
      showEmployeeAdd: false,
      addCallPending: false,
      employeesLoading: false,
      allEmployees: [],
    }
  },
  created() {
    this.listID = this.$route.params.listID
    this.pending = true
    employeeWatchListAPI.getList(this.listID, (r) => {
      this.list = r
      this.pending = false
    })
  },

  computed: {
    addableEmployees() {
      const onListIDs = this.employeesOnList.map(e => e.id)
      return this.allEmployees.filter((ae) => {
        return !onListIDs.includes(ae.id)
      })
    },
    employeesOnList() {
      if (!this.list) {
        return []
      }
      return this.list.employees
    }
  },

  methods: {
    openAddDialog() {
      this.showEmployeeAdd = true
      this.employeesLoading = true
      collectionApi.getEmployees(employees => {
        this.allEmployees = employees
        this.employeesLoading = false
      })
    },

    closeAddDialog() {
      this.showEmployeeAdd = false
      this.addingEmployeesIDs = []
    },

    addEmployeeIDsToList() {
      console.log('what')
      this.addCallPending = true
      employeeWatchListAPI.addEmployeeIDsToList({
        listID: this.listID,
        employeeIDs: this.addingEmployeesIDs
      }, (r) => {
        this.list = r
        this.addingEmployeesIDs = []
        this.addCallPending = false
        this.showEmployeeAdd = false
      }, (e) => {
        console.log(e)
        this.$store.dispatch('global/showSnackbarError', { message: "Something went wrong adding that employee" })
        this.addCallPending = false
      })
    },

    removeEmployeeID(id) {
      employeeWatchListAPI.removeEmployeeIDsFromList({
        listID: this.listID,
        employeeIDs: [id],
      }, (r) => {
        this.list = r
      }, (e) => {
        console.log(e)
        this.$store.dispatch('global/showSnackbarError', { message: "Something went wrong removing that employee" })
      })
    },
  },
}
</script>
